"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayFilters = void 0;
const runtypes_1 = require("runtypes");
exports.DisplayFilters = (0, runtypes_1.Record)({
    hidden: runtypes_1.Boolean,
});
